import {Model} from "./Model";
import {IApiUserLeagueContestants, ContestantType} from "../typings/apiResponse";

/**
 * Object representating the contestants of a user in a league.
 */
export class UserLeagueContestants extends Model {
    constructor(private apiResponse: IApiUserLeagueContestants) {
        super(apiResponse);
    }

    public getLeagueId(): number {
        return this.apiResponse.leagueId;
    }

    public getContestantType(): ContestantType {
        return this.apiResponse.contestantType;
    }

    public getContestantIds(): number[] {
        return this.apiResponse.contestantIds;
    }
}